<script>
  import Modal from '@components/Modal.svelte';
  import Track from '@utils/track';
  import { onMount } from 'svelte';

  export let showModal = false;
  export let mobile = false;
  export let currentUser;
  export let group;
  const cardTitle = 'What is the Optimized Badge?';
  const buttonText = 'See tips';
  let handleCloseButtonClick = async function () {
    Track.optimizedBadgeModalClose({ currentUser: currentUser, groupBaseId: group.id, cardTitle: cardTitle });
    showModal = false;
  };
  let handleHowToEarnClick = async function () {
    Track.optimizedBadgeModalButtonClick({
      currentUser: currentUser,
      groupBaseId: group.id,
      cardTitle: cardTitle,
      buttonText: buttonText,
    });
    window.open(`/list-optimization-tips?group_id=${group.id}`, '_blank').focus();
  };

  let trackModalOpen = async function () {
    Track.optimizedBadgeModalOpen({ currentUser: currentUser, groupBaseId: group.id, cardTitle: cardTitle });
  };
  onMount(async () => {
    trackModalOpen();
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  * :global(.optimized-badge-modal__container-desktop) {
    border-radius: 16px !important;
    height: calc(100vh - 140px) !important;
    overflow: hidden !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding: 0px !important;
    max-width: 672px !important;
  }

  * :global(.optimized-badge-modal__container-mobile) {
    border-radius: 16px !important;
    height: calc(100vh - 140px) !important;
    overflow: hidden !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding: 0px !important;
    width: calc(100% - 20px) !important;
  }
  .scrollable-div {
    height: calc(100vh - 280px);
    overflow-x: hidden;
    overflow-y: scroll;
    max-height: 684px;
    padding-right: 20px;
    &.mobile {
      height: calc(100vh - 285px);
    }
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 24px;
    cursor: pointer;
    &.mobile {
      right: 12px;
      top: 0px;
    }
  }
  .header-message {
    color: #7f7f7f;
    font-family: 'National 2 Narrow';
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 38px; /* 158.333% */
    letter-spacing: -0.5px;
    text-transform: uppercase;
    text-align: center;
    margin-top: 16px;
    &.mobile {
      font-size: 22px;
    }
  }

  * :global(.modal__content) {
    margin-top: 0px !important;
  }
  .content-slot {
    text-align: center;
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 500px;
    padding-left: 24px;
    padding-right: 0px;
    margin-top: 0px;
    .top-image {
      width: 100%;
      margin-top: 20px;
    }
    .content-para {
      overflow: hidden;
      color: #717171;

      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
      text-align: left;
    }
  }
  .see-tips-button {
    display: flex;
    width: 219px;
    height: 48px;
    padding: 14px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-top: 22px;
    margin-bottom: 22px;
    border-radius: 12px;
    background: #7a5cfa;
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;
  }
</style>

<div class="svelte-modal svelte-optimized-badge-modal">
  <Modal
    on:close={() => {
      showModal = false;
    }}
    show={showModal}
    showCloseButton={false}
    fadeInDuration={0}
    closeOnOverlayClick={false}
    containerClass="optimized-badge-modal__container-{mobile ? 'mobile' : 'desktop'}">
    <div slot="header" style="position: relative;">
      <div
        on:click|preventDefault|stopPropagation={handleCloseButtonClick}
        class="close-button {mobile ? 'mobile' : ''}">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M16.9883 4.06171L11.0498 9.99921L16.9883 15.9377L16.458 16.468L15.9277 16.9992L9.98926 11.0607L4.05078 16.9992L3.52051 16.468L2.99023 15.9377L8.92773 9.99921L2.99023 4.06171L4.05078 3.00116L9.98926 8.93866L15.9277 3.00116L16.9883 4.06171Z"
            fill="#B3B3B3" />
        </svg>
      </div>
      <div class="header-message {mobile ? 'mobile' : ''}">{cardTitle}</div>
    </div>
    <div slot="content" class="content-slot">
      <div class="scrollable-div purple-scrollbar-thin {mobile ? 'mobile' : ''}">
        <img
          src={mobile
            ? '/images/list-optimizations/optimized-header-top-mobile.png'
            : '/images/list-optimizations/optimized-header-top.png'}
          class="top-image" />
        <div class="content-para" style="margin-top: 16px; margin-bottom: 16px;">
          The Optimized Badge indicates that your list is high quality and able to be discovered. We’ll boost it in
          rankings, send more traffic, and index it on Google. When you see the “Optimized” badge on your list, it means
          the Benable algorithm thinks it’s really high quality and optimized to be discovered by others. We’ll rank it
          higher, send more traffic to it, and index it on Google.
        </div>
        <div class="content-para" style="margin-bottom: 40px;">
          <span style="font-weight: 700;">List quality</span> really matters on Benable, and having a few great lists makes
          a big difference. Great lists get discovered more, get bookmarked, and get reshared.
        </div>
        <img
          src={mobile
            ? '/images/list-optimizations/optimization-middle-mobile.png'
            : '/images/list-optimizations/optimization-middle.png'}
          class="top-image" />
        <div class="content-para" style="margin-top: 16px; margin-bottom: 16px;">
          Benable will show you when it thinks your list is high quality by adding the Optimized Badge to your list
          automatically. The badge indicates the list is well-suited for Discovery and the Benable algorithm can boost
          it.
        </div>
        <div class="content-para" style="margin-bottom: 12px;">
          Benable will show you when it thinks your list is high quality by adding the Optimized Badge to your list
          automatically. The badge indicates the list is well-suited for Discovery and the Benable algorithm can boost
          it.
        </div>
      </div>
      <div on:click|preventDefault|stopPropagation={handleHowToEarnClick} class="see-tips-button">{buttonText}</div>
    </div>
  </Modal>
</div>
